import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const HoldUntilReply = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22H5.33333C4.08718 22 3.4641 22 3 21.732C2.69596 21.5565 2.44349 21.304 2.26795 21C2 20.5359 2 19.9128 2 18.6667V12ZM8.87945 7.79999H10.4249C10.745 7.79999 11.0044 8.05946 11.0044 8.37953V15.7204C11.0044 16.0405 10.745 16.3 10.4249 16.3H8.87945C8.55937 16.3 8.2999 16.0405 8.2999 15.7204V8.37953C8.2999 8.05946 8.55937 7.79999 8.87945 7.79999ZM13.3794 7.79999H14.9249C15.245 7.79999 15.5044 8.05946 15.5044 8.37953V15.7204C15.5044 16.0405 15.245 16.3 14.9249 16.3H13.3794C13.0594 16.3 12.7999 16.0405 12.7999 15.7204V8.37953C12.7999 8.05946 13.0594 7.79999 13.3794 7.79999Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
